import s from "./style.module.css";

export default function Section({
  item,
  isSelected,
  setActivatedNameAndNavigate,
}) {
  return (
    <div className={s.menuContainer}>
      <h1
        className={`${s.item} ${
          isSelected ? s.shadowPop : s.shadowPopReverse
        } ${s.button}`}
        onClick={() => setActivatedNameAndNavigate(item)}
      >
        {item.name}
      </h1>
    </div>
  );
}
